import { createView } from './createView';
function createIntrinsicViews() {
    return new Proxy({}, {
        get (target, tag) {
            const cached = target[tag];
            if (cached) {
                return cached;
            }
            const component = createView(tag);
            target[tag] = component;
            return component;
        }
    });
}
/**
 * Create intrinsic HTML elements supercharged with support for the css prop and engine intents.
 *
 * @see https://sail.stripe.me/apis/view-tag
 */ export const view = createIntrinsicViews();

//# sourceMappingURL=view.js.map